var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAnalyticsDashboard = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    className: "fill",
    viewBox: "0 0 20 20",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.855 6.917c.456 0 .826-.37.826-.826v-4.44h4.353a.826.826 0 0 0 0-1.651H1.04a1.01 1.01 0 0 0-1.01 1.01V6.09c0 .456.37.826.826.826M6.034 18.348H1.681v-4.44a.826.826 0 0 0-1.652 0v5.083C.03 19.547.482 20 1.04 20h4.995a.826.826 0 0 0 0-1.652M18.961 0h-5.11a.826.826 0 0 0 0 1.652h4.468v4.44a.826.826 0 0 0 1.652 0V1.008A1.01 1.01 0 0 0 18.96 0M19.145 13.083a.826.826 0 0 0-.826.826v4.44h-4.467a.826.826 0 0 0 0 1.65h5.11a1.01 1.01 0 0 0 1.009-1.008v-5.082a.826.826 0 0 0-.826-.826M14.348 15.516a.826.826 0 1 0 1.17-1.166l-2.981-2.99a5.2 5.2 0 0 0 1.008-3.081A5.23 5.23 0 0 0 8.32 3.053a5.233 5.233 0 0 0-5.226 5.226 5.233 5.233 0 0 0 5.226 5.227 5.2 5.2 0 0 0 3.045-.983zM4.745 8.28A3.58 3.58 0 0 1 8.32 4.705a3.58 3.58 0 0 1 3.575 3.574 3.58 3.58 0 0 1-3.575 3.575A3.58 3.58 0 0 1 4.745 8.28"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.03 0h19.94v20H.03z"
  })))));
};
export default SvgAnalyticsDashboard;